/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

interface BreadcrumbContextValue {
  detailLabel: string | undefined;
  setDetailLabel: (label: string | undefined) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  detailLabel: undefined,
  setDetailLabel: () => {},
});

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [detailLabel, setDetailLabel] = useState<string | undefined>();

  const value = useMemo(
    () => ({ detailLabel, setDetailLabel }),
    [detailLabel],
  );

  return (
    <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbDetail() {
  return useContext(BreadcrumbContext);
}
